export interface IAddressType {
  id:number;
  code:string;
  name:string;
  status:string;
  createdAt:string;
  updatedAt:string;
}
